/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/~/lodash/fp/placeholder.js
 **/